import { render, staticRenderFns } from "./Saverstatus.vue?vue&type=template&id=c8d5d878"
import script from "./Saverstatus.vue?vue&type=script&lang=js"
export * from "./Saverstatus.vue?vue&type=script&lang=js"
import style0 from "./Saverstatus.vue?vue&type=style&index=0&id=c8d5d878&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports